var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "1", type: "primary", disabled: _vm.isEdit },
                    on: { click: _vm.autoAllocateCargoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoDistribution")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "2", type: "primary", disabled: _vm.isEdit },
                    on: { click: _vm.allocateCargoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ManualDistribution")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "3",
                      type: "primary",
                      disabled: !_vm.btUnlockEnabled
                    },
                    on: { click: _vm.removeRelationHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock2")))]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": "130119",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("warehouse-record-dialog", {
        attrs: { visible: _vm.warehouseRecordDialog.visible, lob: _vm.job.lob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseRecordDialog, "visible", $event)
          },
          selectWarehouseHandler: _vm.selectWarehouseHandler
        }
      }),
      _c("picture-view-window", {
        attrs: {
          visible: _vm.pictureView.visible,
          job: _vm.job,
          model: _vm.pictureView.model,
          title: _vm.pictureView.title,
          "file-name": _vm.pictureView.fileName,
          type: _vm.pictureView.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.pictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }